import { ClockCounterClockwise, CheckCircle } from "@phosphor-icons/react";

const formatTimestamp = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

const relativeFrom = (iso) => {
  if (!iso) return "";
  try {
    const ms = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(ms / 60000);
    if (mins < 1) return "hace unos segundos";
    if (mins < 60) return `hace ${mins} min`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `hace ${hours}h`;
    const days = Math.floor(hours / 24);
    return `hace ${days}d`;
  } catch {
    return "";
  }
};

const CheckinHistory = ({ items = [], compact = false }) => {
  const list = [...items].reverse();
  return (
    <div data-testid="checkin-history">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-lg tracking-tight flex items-center gap-2">
          <ClockCounterClockwise size={18} weight="duotone" className="text-aqua" />
          Historial de check-ins
        </h2>
        <span className="text-xs uppercase tracking-[0.25em] text-white/50">
          Últimos {Math.min(list.length, 10)}
        </span>
      </div>

      {list.length === 0 ? (
        <div className="bg-surface border border-dashed border-border rounded-xl p-6 text-center text-white/45 text-sm">
          Aún no hay check-ins registrados.
        </div>
      ) : (
        <ol
          className={
            "bg-surface border border-border rounded-xl divide-y divide-border/60 overflow-hidden " +
            (compact ? "" : "")
          }
        >
          {list.slice(0, 10).map((item, i) => (
            <li
              key={`${item.at}-${i}`}
              className="flex items-center gap-3 px-4 py-3 hover:bg-aqua/[0.03] transition-colors"
              data-testid={`checkin-history-item-${i}`}
            >
              <div className="w-8 h-8 rounded-full bg-aqua/10 border border-aqua/30 flex items-center justify-center text-aqua shrink-0">
                <CheckCircle size={16} weight="duotone" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="mono font-mono text-sm text-white">
                  {formatTimestamp(item.at)}
                </div>
              </div>
              <span className="text-xs text-white/45 mono shrink-0">
                {relativeFrom(item.at)}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default CheckinHistory;
